import { render, staticRenderFns } from "./payCheck.vue?vue&type=template&id=6ab88595&scoped=true"
import script from "./payCheck.vue?vue&type=script&lang=js"
export * from "./payCheck.vue?vue&type=script&lang=js"
import style0 from "./payCheck.vue?vue&type=style&index=0&id=6ab88595&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab88595",
  null
  
)

export default component.exports